
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTicketCategoryDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(150)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    keywords: new FormControl<Array<string> | undefined>([], [Validators.required]),
    sortableRank: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
})
;
}
      